// src/modules/hollymontt-admin/services/courseReports.js

import apiClientBlob from "@/services/ApiClient";

const name = "course-reports";

export default {
  name,

  getPortfolioRankingBanana(courseId) {
    return apiClientBlob.get(`/courses/${courseId}/banana-ranking-export`, {
      responseType: "arraybuffer",
    });
  },

  getPortfolioRankingTwoTails(courseId) {
    return apiClientBlob.get(`/courses/${courseId}/simulator-ranking-export`, {
      responseType: "arraybuffer",
    });
  },

  getLeaderboardBanana(courseId, startDate, endDate) {
    return apiClientBlob.get(
      `/courses/${courseId}/banana-challenge-report?start=${startDate}&end=${endDate}`,
      {
        responseType: "arraybuffer",
      }
    );
  },

  getLeaderboardTwoTails(courseId, startDate, endDate) {
    return apiClientBlob.get(
      `/courses/${courseId}/twotails-investment-competition?start=${startDate}&end=${endDate}`,
      {
        responseType: "arraybuffer",
      }
    );
  },

  getClientActivityReport(courseId, startDate, endDate) {
    let url = `/courses/${courseId}/client-activity-report`;
    if (startDate && endDate) {
      url += `?start=${startDate}&end=${endDate}`;
    }
    return apiClientBlob.get(url, {
      responseType: "arraybuffer",
    });
  },

  getVideoTrackingSummary(courseId, startDate, endDate) {
    let url = `/courses/${courseId}/video-tracking-summary`;
    if (startDate && endDate) {
      url += `?start=${startDate}&end=${endDate}`;
    }
    return apiClientBlob.get(url, {
      responseType: "arraybuffer",
    });
  },

  getVideoTrackingPerModuleActivity(courseId, startDate, endDate) {
    let url = `/courses/${courseId}/video-tracking-per-module-activity`;
    if (startDate && endDate) {
      url += `?start=${startDate}&end=${endDate}`;
    }
    return apiClientBlob.get(url, {
      responseType: "arraybuffer",
    });
  },

  getVideoTrackingLessonsActivity(courseId, startDate, endDate) {
    let url = `/courses/${courseId}/video-tracking-lessons-activity`;
    if (startDate && endDate) {
      url += `?start=${startDate}&end=${endDate}`;
    }
    return apiClientBlob.get(url, {
      responseType: "arraybuffer",
    });
  },
};
